enum ErrorTypes {
  UNAUTHORIZED = 'UnauthorizedError',
}

export default ErrorTypes;
